function devtricker_session_post_like_savePostInLikedPosts(postId) {
    try {
        const key = 'devtricker_liked_posts';
        const currentData = JSON.parse(sessionStorage.getItem(key) || '[]');

        const exists = currentData.some(item => item.postId === postId);
        if (!exists) {
            currentData.push({
                postId: postId,
                dateAdded: new Date().toISOString()
            });

            sessionStorage.setItem(key, JSON.stringify(currentData));
            devtricker_log(null, devtricker_log_level.INFO, "Post successfully added to liked posts in sessionStorage.");
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

function devtricker_session_post_like_deletePostFromLikedPosts(postId) {
    try {
        const key = 'devtricker_liked_posts';
        const currentData = JSON.parse(sessionStorage.getItem(key) || '[]');

        const filtered = currentData.filter(item => item.postId !== postId);
        const changed = currentData.length !== filtered.length;

        if (changed) {
            sessionStorage.setItem(key, JSON.stringify(filtered));
            devtricker_log(null, devtricker_log_level.INFO, "Post successfully removed from liked posts in sessionStorage.");
        } else {
            devtricker_log(null, devtricker_log_level.ERROR, "Post not found in liked posts.");
            throw new Error("Post not found in liked posts.");
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

function devtricker_session_post_like_isPostLiked(postId) {
    try {
        const key = 'devtricker_liked_posts';
        const currentData = JSON.parse(sessionStorage.getItem(key) || '[]');

        return currentData.some(item => item.postId === postId);
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, "Error checking liked post in sessionStorage.");
        throw error;
    }
}